import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { Pos } from '../../type';

export const getAllPos = async (): Promise<Pos[]> => {
    const { data } = await axios.get(`v1/get-pos-devices`);
    return data.devices;
};

type QueryFnType = typeof getAllPos;

type UseCorpsOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const usePos = ({ config }: UseCorpsOptions = {}) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['pos'],
        queryFn: () => getAllPos(),
    });
};
